import React from 'react';
import { VMSLogo } from '../../icons/VMSLogo';
import { LoginForm } from './LoginForm';
import { LoginCover } from './LoginCover';
import { Copyright, Paragraph, Title } from '../../components/Text';
import { FixedFlexBox } from '../../components/Cover';
import { Flex } from '../../components/Flex';

const Login = ({ error, onSubmit, onCancel, switchOrg, orgs }) => {
    let title = switchOrg
        ? <Title h3>Switch an organization</Title>
        : <>
            <Title>Your session has ended. To sign in, please click the button below and you will be redirected to the login page.</Title>
            <Paragraph color="var(--sp-error-hover-color)">Please note that the authentication method has changed and you will be redirected to a new login page.</Paragraph>
            <Paragraph color="var(--sp-error-hover-color)">If this is your first time logging into the new system, please follow the instructions on this page and use the email that you have been using to login previously.</Paragraph>
            <Paragraph color="var(--sp-error-hover-color)"><b>Register as a new user</b> if you do not have an existing VMS Training Center account or have never received an invitation from the VSI team.</Paragraph>
        </>

    return(
        <>
            <LoginCover />
            <FixedFlexBox
                height="100%"
                width="360px"
                top={0}
                left={0}
                padding="32px"
                background="#FFFFFF"
                box-shadow="4px 0px 8px rgba(6, 24, 52, 0.3)"
            >
                <div>
                    <div style={{ marginBottom: "32px" }}>
                        <VMSLogo />
                    </div>
                    <Flex direction="column" margin={{ bottom: "32px" }} gap={{ bottom: 12 }}>
                        {title}
                    </Flex>
                    {error && <div style={{ color: "#FF5A5A" }}>{error}</div>}
                    <LoginForm
                        onSubmit={onSubmit}
                        onCancel={onCancel}
                        switchOrg={switchOrg}
                        orgs={orgs}
                    />
                </div>
                <Flex direction="column">
                    <Flex direction="column" margin={{ bottom: "12px"}}>
                        <Copyright>&copy; Copyright 2014&ndash;{new Date().getFullYear()}, VMS Software, Inc.</Copyright>
                        <Copyright>All rights reserved.</Copyright>
                    </Flex>
                    <Flex direction="column">
                        <Copyright>VMS SOFTWARE INC. 6 Liberty Sq</Copyright>
                        <Copyright>PMB # 294</Copyright>
                        <Copyright>Boston, MA 02109, USA</Copyright>
                    </Flex>
                </Flex>
            </FixedFlexBox>
        </>
    );
};

export { Login };